import * as Actions from "../actions/_ActionTypes";
import * as Pre from "../actions/_PreActionNames";
import * as CONSTS from "../../assets/consts";
import * as SecureStore from "../components_v2/DeviceAsyncStorage";
import AppLog from "../logger";

const initState = {
  newUserMessages: 0,
};

const UserMessageReducer = (state = initState, action) => {
  const _state = { ...state };
  switch (action.type) {
    case Pre.USERMESSAGE + Actions.NEW_MESSAGES_COUNT:
      let { count } = JSON.parse(action.payload.data);
      _state.newUserMessages = count || 0;
      break;
    case Actions.LOGOUT:
      _state.newUserMessages = 0;
      break;
  }

  return _state;
};

export default UserMessageReducer;
